import projection from '../generated/pwg5m1f1.json';
import { AcceptanceManifest } from '../types';

/** Generated by scripts/build-acceptance-projections.js from the canonical Contract. */
export const pwg5m1f1AcceptanceManifest = projection as AcceptanceManifest;
